import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import ClipLoader from "react-spinners/ClipLoader";
import PropTypes from "prop-types";
import axios from "axios";
import { Dialog, Button, CustomCheckBox } from "hesus-ui-kit";
import ParametersFormat from "./ParametersFormat";
import { Title } from "../../AddEditQuote.styled";
import UserInfo from "@utils/UserInfo";
import {
  HeaderWrapper,
  FormBody,
  OptionsWrapper,
  SectionContainer,
  ButtonWrapper,
  SpecificConditionTitle,
  SpecificConditionTitleLabel,
  SpecificConditionLabel,
  OuterWrapper,
} from "./AddEditSpecificCondition.styled";

const AddEditSpecificCondition = (props) => {
  const {
    t,
    conditionData,
    addCondition,
    deleteCondition,
    addParameters,
    onPopUpClose,
    onPopUpValidate,
  } = props;
  const [loading, setLoading] = useState(false);
  const [specificConditionList, setSpecificConditionList] = useState([]);
  const countries = UserInfo.countryId();

  const getSpecificConditionList = () => {
    setLoading(true);
    axios
      .get(`/quote/specificConditions?countries=[${countries}]`)
      .then((response) => {
        setSpecificConditionList(response?.data?.specificCondition);
        setLoading(false);
      })
      .catch((error) => {
        setContactList([]);
        setLoading(false);
      });
  };

  useEffect(() => {
    getSpecificConditionList();
  }, []);

  const onConditionClick = (e, parentId, data, type) => {
    if (e.target.checked) addCondition(parentId, data, type);
    else deleteCondition(parentId, data?.id, type, "popup");
  };

  return (
    <>
      <Dialog width="40rem">
        <div>
          <HeaderWrapper>
            <Title>{t("QUOTE_SELECT_SPECIFIC_CONDITIONS")}</Title>
          </HeaderWrapper>
          <FormBody>
            <OptionsWrapper>
              <SectionContainer>
                {specificConditionList?.length > 0 && (
                  <>
                    {specificConditionList.map((condition) => {
                      const parent = conditionData.find(
                        (data) => data.parent.id === condition.id
                      );
                      return (
                        <OuterWrapper
                          column="1fr"
                          key={"SpecificConditionList" + condition.id}
                        >
                          {condition.isTitle === 0 && (
                            <div
                              style={{ margin: "5px 0px 5px 15px" }}
                              key={`row-${condition.id}`}
                            >
                              <CustomCheckBox
                                id={condition.id}
                                key={condition.id}
                                dataId={condition.id}
                                onChange={(e) => {
                                  onConditionClick(
                                    e,
                                    condition.id,
                                    condition,
                                    "parent"
                                  );
                                }}
                                checked={!!parent}
                              />
                              {condition.title && condition.title !== "" && (
                                <SpecificConditionTitleLabel>
                                  {condition.title}
                                </SpecificConditionTitleLabel>
                              )}
                              <SpecificConditionLabel
                                color={
                                  condition.title != null
                                    ? "#767676"
                                    : "#474747"
                                }
                                marginLeft="25px"
                              >
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: condition.content,
                                  }}
                                ></div>
                              </SpecificConditionLabel>
                              {condition.parameters &&
                                condition.parameters !== undefined && (
                                  <ParametersFormat
                                    data={condition}
                                    parametersValue={
                                      parent && parent.children.length > 0
                                        ? parent.children[0]?.parametersValue
                                          ? JSON.parse(
                                              parent.children[0]
                                                ?.parametersValue
                                            )
                                          : null
                                        : null
                                    }
                                    parametersError={
                                      parent && parent.children.length > 0
                                        ? parent.children[0]?.parametersError
                                        : null
                                    }
                                    addParameters={addParameters}
                                  />
                                )}
                            </div>
                          )}
                          {condition.isTitle === 1 && (
                            <>
                              <SpecificConditionTitle>
                                {condition.title}
                              </SpecificConditionTitle>
                              {condition.children?.length > 0 &&
                                condition.children.map((child) => {
                                  const childInfo = parent?.children.find(
                                    (data) => data.id === child.id
                                  );

                                  return (
                                    <div
                                      style={{ margin: "5px 0px 5px 15px" }}
                                      key={`row-${child.id}`}
                                    >
                                      <CustomCheckBox
                                        id={child.id}
                                        key={child.id}
                                        dataId={child.id}
                                        onChange={(e) => {
                                          onConditionClick(
                                            e,
                                            condition.id,
                                            child,
                                            "child"
                                          );
                                        }}
                                        checked={!!childInfo}
                                      />
                                      {!!child.title && child.title !== "" && (
                                        <SpecificConditionTitleLabel>
                                          {child.title}
                                        </SpecificConditionTitleLabel>
                                      )}
                                      <SpecificConditionLabel
                                        color={
                                          child.title != null
                                            ? "#767676"
                                            : "#474747"
                                        }
                                        marginLeft="25px"
                                      >
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: child.content,
                                          }}
                                        ></div>
                                      </SpecificConditionLabel>
                                      {child.parameters &&
                                        child.parameters !== undefined && (
                                          <ParametersFormat
                                            data={child}
                                            parametersValue={
                                              childInfo?.parametersValue
                                                ? JSON.parse(
                                                    childInfo.parametersValue
                                                  )
                                                : null
                                            }
                                            parametersError={
                                              childInfo?.parametersError
                                            }
                                            addParameters={addParameters}
                                          />
                                        )}
                                    </div>
                                  );
                                })}
                            </>
                          )}
                        </OuterWrapper>
                      );
                    })}
                  </>
                )}
                {specificConditionList?.length === 0 && (
                  <OuterWrapper>
                    {t("QUOTE_NO_SPECIFIC_CONDITIONS")}
                  </OuterWrapper>
                )}
              </SectionContainer>
            </OptionsWrapper>
          </FormBody>
          <ButtonWrapper>
            <Button
              styles={{
                color: "#333",
                background: "#fff",
                border: "1px solid #ccc",
                marginRight: "0.32rem",
                "&:hover": {
                  backgroundColor: "#ccc",
                },
              }}
              onClick={onPopUpClose}
            >
              {t("CANCEL")}
            </Button>

            <Button
              styles={{
                color: "white",
                background: "#1BACE4",
                border: "1px solid #1BACE4",
                marginRight: "0.32rem",
                "&:hover": {
                  backgroundColor: "#1589b6",
                },
              }}
              onClick={onPopUpValidate}
            >
              <>
                {loading && <ClipLoader size={15} color="#fff" />}
                {!loading && t("VALIDATE")}
              </>
            </Button>
          </ButtonWrapper>
        </div>
      </Dialog>
    </>
  );
};

AddEditSpecificCondition.propTypes = {
  t: PropTypes.func.isRequired,
  conditionData: PropTypes.object.isRequired,
  addCondition: PropTypes.func.isRequired,
  deleteCondition: PropTypes.func.isRequired,
  addParameters: PropTypes.func.isRequired,
};

export default withTranslation()(AddEditSpecificCondition);
